import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { WarningCircle, Warning, Info, ShieldCheck, ArrowRight } from "@phosphor-icons/react";
import { StatusBadge } from "@/components/pcp";
import { brDate, fmtInt, fmtPct } from "./util";

const LIMITE = 5;

function ChipsAlertas({ alertas, contexto }) {
  const total = alertas.critica + alertas.atencao + alertas.informativa;
  const virada = brDate(contexto.data_virada);
  return (
    <div className="dash-alertas-chips" data-testid="alertas-compactos">
      {contexto.em_fase_testes ? (
        <span className="chip" data-testid="alertas-fase-testes"><Info size={12} weight="bold" /> Alertas do Diretor Operacional: coleta a partir de {virada}</span>
      ) : total === 0 ? (
        <span className="chip" style={{ color: "#16A34A" }} data-testid="alertas-vazio"><ShieldCheck size={12} weight="bold" /> Sem alertas operacionais</span>
      ) : (
        <>
          {alertas.critica > 0 && <span className="chip" style={{ color: "#DC2626", borderColor: "#DC2626" }} data-testid="alerta-badge-critica"><WarningCircle size={12} weight="bold" /> {alertas.critica} crítica(s)</span>}
          {alertas.atencao > 0 && <span className="chip" style={{ color: "#D97706", borderColor: "#D97706" }} data-testid="alerta-badge-atencao"><Warning size={12} weight="bold" /> {alertas.atencao} atenção</span>}
          {alertas.informativa > 0 && <span className="chip" data-testid="alerta-badge-informativa"><Info size={12} weight="bold" /> {alertas.informativa} informativa(s)</span>}
        </>
      )}
    </div>
  );
}

export default function AtencaoHoje({ atencao, alertas, contexto, filtros }) {
  const [todas, setTodas] = useState(false);
  const nav = useNavigate();
  const lista = todas ? atencao : atencao.slice(0, LIMITE);
  const paralisadas = atencao.filter((a) => a.status === "Paralisada").length;
  return (
    <div className="pcp-card" style={{ padding: 20 }} data-testid="atencao-hoje">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 12, flexWrap: "wrap", marginBottom: 12 }}>
        <div>
          <div className="overline" style={{ color: atencao.length ? "#DC2626" : undefined }}>Atenção hoje</div>
          <h2 className="font-display font-bold text-lg mt-1">OS que exigem ação</h2>
          <div style={{ fontSize: "0.75rem", color: "#71717A", marginTop: 2 }}>
            Posição em {brDate(filtros.referencia)} · ordenadas por alertas críticos e dias de atraso
            {paralisadas > 0 && <> · <strong style={{ color: "#DC2626" }}>{paralisadas} paralisada(s)</strong> com prazo vencido — análise separada</>}
            {contexto.em_fase_testes && <> · <span className="dash-badge-validacao" style={{ fontSize: "0.65rem" }}>dados em validação</span></>}
          </div>
        </div>
        <ChipsAlertas alertas={alertas} contexto={contexto} />
      </div>
      {atencao.length === 0 ? (
        <div className="dash-vazio" style={{ color: "#16A34A", display: "flex", gap: 8, alignItems: "center" }} data-testid="atencao-vazio">
          <ShieldCheck size={18} weight="bold" /> Nenhuma OS atrasada ou com alerta crítico no recorte.
        </div>
      ) : (
        <>
          <div className="dash-table-wrap">
            <table className="pcp-table dash-table-atencao" data-testid="atencao-tabela">
              <thead>
                <tr><th>OS</th><th>Contrato / contratante</th><th>Prazo</th><th style={{ textAlign: "right" }}>Atraso</th><th>Status</th><th>Responsável</th><th style={{ textAlign: "right" }}>Avanço</th><th /></tr>
              </thead>
              <tbody>
                {lista.map((a) => (
                  <tr key={a.os_id} onClick={() => nav(`/ordens/${a.os_id}`)} style={{ cursor: "pointer" }} data-testid={`atencao-linha-${a.os_id}`}
                    className={a.status === "Paralisada" ? "dash-linha-paralisada" : ""}>
                    <td className="font-mono font-semibold" data-label="OS">
                      {a.numero}
                      {a.critica > 0 && <span className="dash-mini-badge" title={`${a.critica} alerta(s) crítico(s)`} data-testid={`atencao-critica-${a.os_id}`}><WarningCircle size={11} weight="bold" /> {a.critica}</span>}
                    </td>
                    <td data-label="Contrato"><span className="font-mono">{a.contrato_numero || "—"}</span> <span style={{ color: "#52525B" }}>· {a.contratante}</span></td>
                    <td className="font-mono" data-label="Prazo">{brDate(a.prazo_conclusao)}</td>
                    <td className="font-mono" data-label="Atraso" style={{ textAlign: "right", color: a.dias_atraso > 0 ? "#DC2626" : "#52525B", fontWeight: 600 }}>
                      {a.dias_atraso > 0 ? `${fmtInt(a.dias_atraso)} d` : "—"}
                    </td>
                    <td data-label="Status"><StatusBadge status={a.status} /></td>
                    <td data-label="Responsável" style={{ color: a.responsavel ? undefined : "#A1A1AA" }}>{a.responsavel || a.equipe || "não cadastrado"}</td>
                    <td className="font-mono" data-label="Avanço" style={{ textAlign: "right" }}>{fmtPct(a.avanco)}</td>
                    <td style={{ textAlign: "right" }}><ArrowRight size={14} weight="bold" /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {atencao.length > LIMITE && (
            <button type="button" className="btn btn-ghost btn-sm" style={{ marginTop: 8 }} onClick={() => setTodas(!todas)} data-testid="atencao-ver-todas">
              {todas ? "Mostrar só as 5 mais urgentes" : `Ver todas (${atencao.length})`}
            </button>
          )}
        </>
      )}
    </div>
  );
}
